export enum ProjectChecklistSortType {
    Id,
    Name,
    Description,
    Order,
    ProjectName,
    IsDeleted
}
